import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import { responsiveThemeStyle } from "../../theme/responsive";
import { AnimatePresence, motion } from 'framer-motion';
var alignment = {
  start: 'start',
  center: 'center',
  end: 'end',
  stretch: 'stretch'
};
var justifyContent = {
  start: 'start',
  end: 'end',
  center: 'center',
  stretch: 'stretch',
  spaceAround: 'space-around',
  spaceBetween: 'space-between',
  spaceEvenly: 'space-evenly'
};

var getSizeStyle = function getSizeStyle(scale) {
  return "\n  0 0 ".concat(scale * 100, "%\n");
};

var size = {
  120: '120px',
  240: '240px',
  360: '360px',
  480: '480px',
  640: '640px',
  '1/2': getSizeStyle(1 / 2),
  '1/3': getSizeStyle(1 / 3),
  '2/3': getSizeStyle(2 / 3),
  '1/4': getSizeStyle(1 / 4),
  '3/4': getSizeStyle(3 / 4),
  '1/5': getSizeStyle(1 / 5),
  '2/5': getSizeStyle(2 / 5),
  '3/5': getSizeStyle(3 / 5),
  '4/5': getSizeStyle(4 / 5)
};
export function Tile(_ref) {
  var children = _ref.children,
      _ref$alignY = _ref.alignY,
      alignY = _ref$alignY === void 0 ? 'start' : _ref$alignY,
      _ref$alignX = _ref.alignX,
      alignX = _ref$alignX === void 0 ? 'stretch' : _ref$alignX,
      _ref$justifyContent = _ref.justifyContent,
      justifyContent = _ref$justifyContent === void 0 ? 'start' : _ref$justifyContent,
      animate = _ref.animate,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 16 : _ref$gap,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 240 : _ref$size,
      other = _objectWithoutProperties(_ref, ["children", "alignY", "alignX", "justifyContent", "animate", "gap", "size"]);

  var wrappedChildren = React.Children.map(children, function (child) {
    return React.isValidElement(child) ? /*#__PURE__*/React.createElement(TileItem, _extends({
      as: animate ? motion.div : undefined,
      key: child.key
    }, animate), child) : null;
  });
  var childrenWithPresence = animate ? /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false
  }, wrappedChildren) : wrappedChildren;
  return /*#__PURE__*/React.createElement(TileWrapper, _extends({
    $gap: gap,
    $alignY: alignY,
    $alignX: alignX,
    $size: size,
    $justifyContent: justifyContent
  }, other), childrenWithPresence);
}
var TileItem = styled.div.withConfig({
  displayName: "Tile__TileItem",
  componentId: "vapor__ktb355-0"
})(["min-width:0;"]);
var responsiveGap = responsiveThemeStyle('gridGap', 'spaces');
var TileWrapper = styled.div.withConfig({
  displayName: "Tile__TileWrapper",
  componentId: "vapor__ktb355-1"
})(["display:grid;grid-template-columns:repeat(auto-fit,minmax(", ",1fr));", ";align-items:", ";justify-items:", ";justify-content:", ";width:100%;", "{}"], function (p) {
  return size[p.$size];
}, function (p) {
  return responsiveGap(p.$gap);
}, function (p) {
  return alignment[p.$alignY];
}, function (p) {
  return alignment[p.$alignX];
}, function (p) {
  return alignment[p.$justifyContent];
}, TileItem);
export var testExports = {
  TileItem: TileItem
};